import React, { useState, useEffect, useRef } from "react";

interface ImageProps {
  asset: string | undefined;
  className?: string;
}

const LazyImage: React.FC<ImageProps> = ({ asset, className }) => {
  const [isVisible, setIsVisible] = useState(false);
  const imgRef = useRef<HTMLImageElement | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // Stop observing once visible
        }
      },
      { threshold: 0.1 }
    );

    if (imgRef.current) {
      observer.observe(imgRef.current);
    }

    return () => {
      if (imgRef.current) {
        observer.disconnect();
      }
    };
  }, []);

  return (
    <img
      ref={imgRef}
      src={isVisible ? asset : ""}
      className={className}
      alt=""
    />
  );
};

export default LazyImage;